module.exports = __webpack_public_path__ + "img/home7.4a9820f0.svg";